import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Result.css";

const API = process.env.REACT_APP_API_URL;

function Result() {
    const navigate = useNavigate();

    const [data, setData] = useState(null);

    const studentId = sessionStorage.getItem("studentId");

    const paper1Url = `${API}/omr/${studentId}/1`;
    const paper2Url = `${API}/omr/${studentId}/2`;
    const certificateUrl = `${API}/certificate/${studentId}`;

    useEffect(() => {
        if (!studentId) {
            navigate("/");
            return;
        }

        axios.get(`${API}/result-by-id/${studentId}`)
            .then(res => {
                setData(res.data);
            })
            .catch(() => {
                alert("Failed to load result");
                navigate("/");
            });
    }, []);

    // ✅ Download helper
    const downloadImage = async (url, name) => {
        const response = await fetch(url);
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        link.click();
    };

    if (!data) return <h2>Loading...</h2>;

    return (
        <div className="result-container">

            {/* Student Info */}
            <div className="student-info">
                <h2>{data.candidateName}</h2>
                <p>Seat No: {data.candidateNumber}</p>
                <p>{data.school}</p>

                {/* ✅ Marks Section */}
                <div className="marks">
                    <p><strong>Paper 1 Marks:</strong> {data.paper1Marks}</p>
                    <p><strong>Paper 2 Marks:</strong> {data.paper2Marks}</p>
                </div>
            </div>

            {/* OMR Section */}
            <div className="omr-section">

                <div className="omr-card">
                    <h3>Paper 1</h3>
                    <img src={paper1Url} alt="Paper1" />
                    <button onClick={() => downloadImage(paper1Url, "Paper1.jpg")}>
                        Download
                    </button>
                </div>

                <div className="omr-card">
                    <h3>Paper 2</h3>
                    <img src={paper2Url} alt="Paper2" />
                    <button onClick={() => downloadImage(paper2Url, "Paper2.jpg")}>
                        Download
                    </button>
                </div>

            </div>

            {/* Certificate */}
            <div className="certificate-section">
                <button
                    className="certificate-btn"
                    onClick={() => downloadImage(certificateUrl, "Certificate.jpg")}
                >
                    Download Certificate
                </button>
            </div>

            {/* Back */}
            <button className="back-btn" onClick={() => navigate("/")}>
                Back
            </button>

        </div>
    );
}

export default Result;